import type { AgentFocus } from '@tunasong/agent-context'
import type { FC } from 'react'
import styles from './agent-chat.module.css'
import { focusChipLabel } from './focus-chip-label.js'

export interface FocusChipProps {
  focus: AgentFocus
  onDismiss: () => void
}

/** The anchored ask, shown inside the composer until it is sent or dismissed */
export const FocusChip: FC<FocusChipProps> = props => {
  const { focus, onDismiss } = props
  const label = focusChipLabel(focus)
  return (
    <div className={styles.focusChip} aria-label={`Focus: ${focus.type} · ${label}`} data-testid="focus-chip">
      <span>{label}</span>
      <button type="button" aria-label="dismiss focus" onClick={onDismiss}>
        ×
      </button>
    </div>
  )
}
